import { __ } from '@wordpress/i18n'
import { useContext } from 'react';
import SbUtils from '../../../../Utils/SbUtils';
import SettingsScreenContext from '../../../Context/SettingsScreenContext';
import SelectSourcesSection from "../../CreationProcess/SelectSourcesSection";

const ManageSource = ( props ) => {
    const {
        sbCustomizer,
        editorNotification,
        editorConfirmDialog,
        sources,
        editorTopLoader,
    } = useContext( SettingsScreenContext) ;

    const deleteSource = ( source ) => {
        const confirmDialogInfo = {
                active : true,
                heading : `${ __('Delete ', 'sb-customizer') + '"'+source.display_name +'"?'  }`,
                description : __( 'If you delete this source then new posts can no longer be retrieved for feeds using this source.', 'sb-customizer' ),
                confirm : {}
        },
        notificationsContent = {
            success : {
                icon : 'success',
                text : __( 'Source Deleted!', 'sb-customizer' )
            }
        };

        confirmDialogInfo.confirm.onConfirm = () => {
            const formData = {
                action : 'sbtt_delete_source',
                sourceID : source.id,
                sourceOpenID : source.open_id,
            }
            SbUtils.ajaxPost(
                sbCustomizer.ajaxHandler,
                formData,
                ( data ) => { //Call Back Function
                    if( data?.success ){
                        sources.setSourcesList( data?.data?.sourcesList )
                    }
                },
                editorTopLoader,
                editorNotification,
                notificationsContent
            )
        }
        editorConfirmDialog.setConfirmDialog( confirmDialogInfo )

    }


    return (
        <>
            <SelectSourcesSection
                context='settingspage'
                deleteSource={ ( source ) => {
                    deleteSource( source )
                } }
            />
        </>
    )
}

export default ManageSource;